import { useCallback, useState } from 'react';
import { CheckboxTypes } from '../components/CheckboxComponent/CheckboxSelector.types';

type UseCheckboxSelectorProps = Pick<
  CheckboxTypes,
  'disabled' | 'onChange' | 'value' | 'checked' | 'filterType'
>;

interface UseCheckboxSelectorReturn {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isRegionFilter: boolean;
  handleChange: () => void;
  handleKeyPress: (e: React.KeyboardEvent) => void;
}

const useCheckboxSelector = ({
  disabled,
  onChange,
  value,
  checked,
  filterType,
}: UseCheckboxSelectorProps): UseCheckboxSelectorReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const isRegionFilter = filterType === 'offerRegion';

  const handleChange = useCallback(() => {
    if (disabled) return;
    onChange(value, !checked);
  }, [disabled, onChange, value, checked]);

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (disabled) return;
      if (e.key !== ' ') return;
      e.preventDefault();
      handleChange();
    },
    [disabled, handleChange],
  );

  return { isOpen, setIsOpen, isRegionFilter, handleChange, handleKeyPress };
};

export default useCheckboxSelector;
